import { useQuery } from "@tanstack/react-query";

import { createActivationApi } from "../../services/api";

export const TRACKER_CAMPAIGNS_QUERY_KEY = "TRACKER_CAMPAIGNS_QUERY_KEY";

export const useGetRankTrackerCampaignsQuery = () => {
    return useQuery({
        queryKey: [TRACKER_CAMPAIGNS_QUERY_KEY],
        queryFn: async () => {
            const { rankTracker } = createActivationApi();

            return await rankTracker.getCampaigns();
        },
    });
};
